import React from 'react'

function EmailManager() {
  return (
    <div>EmailManager</div>
  )
}

export default EmailManager